import React, { useState, useEffect, useRef } from "react";
import { object, array, bool, string, number, func } from "prop-types";
import { SocialShare, Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";

import StoryCard from "../../story-templates/StoryCard";
import RelatedStories from "../RelatedStories";
import LatestStories from "../LatestStories";
import StoryTag from "../../story-templates/StoryTag";
import MetypeCommentWrapper from "../../MetypeComments";
import SocialShareTemplate from "../SocialShareTemplate";
import ScrollSnap from "../../atoms/ScrollSnap";
import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import RightArrowButton from "../../atoms/icons/right-arrow-button";
import CloseIcon from "../../atoms/icons/close";
import { toBanglaNum } from "../../utils/utils";
import DfpAd from "../../dfp-ad";
import { setMetypeBar } from "../../helper/actions";
import { staticTexts } from "../../utils/Translate";
import LightBox from "../LightBox";
import BookmarkViewIcon from "../../atoms/BookmarkViewIcon";
import FullScreenIcon from "../../../../assets/icons/full-screen-icon.png";
import { Share, Print } from "../../atoms/icons/StoryPageIcons";
import ShareAllTemplate from "../ShareAllTemplate";
import { MetypeReactionsWidget } from "../../atoms/metype-react";
import Loadericon from "../../atoms/load-more-button-loader";
import StoryAds from "../StoryAds";

import "./storyContent.m.css";

const StoryContent = ({
  story = null,
  slicedStoryCards = [],
  metypeConfig = null,
  checkKeyElements = false,
  imageElements = null,
  domainSlug,
  setMetypeBar,
  isMetypeBar,
  publisherAttributes,
  isMobile,
  jwtToken,
  authHost,
  bottomAd,
  bottomAdPresence,
  member,
  storyFromReducer,
  scrollIndex,
  datatrackingcategory = "",
  datatrackingaction = "",
  sponsorId,
  lang,
}) => {
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [lowerBottomAd, setLowerBottomAd] = useState(false);
  const [isSocialShare, setSocialShare] = useState(false);
  const ref = useRef(null);
  const metypeRef = useRef(null);
  const [metypeTarget, setMetypeTarget] = useState(null);
  const [relStories, setRelStories] = useState([]);

  const selectionChange = (index) => setSelectedIndex(index);
  const sectionName = get(story, ["sections", "0"], "");
  const firstStorySeo = get(story, ["seo", "meta-keywords", "0"], null);
  useEffect(() => {
    if (story["story-template"] === "live-blog") {
      global.deviceWidth < 1264 && setLowerBottomAd(!lowerBottomAd);
    }
    if (story.tags.length > 0) {
      fetch(
        `/api/v1/advanced-search?tag-name=${decodeURIComponent(firstStorySeo)}&not-story-content-ids=${
          story.id
        }&limit=8&sort=latest-published&fields=headline,subheadline,slug,url,hero-image-s3-key,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,story-template,metadata`
      )
        .then(function (res) {
          // Examine the text in the response
          res.json().then(function (data) {
            setRelStories(data.items);
          });
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
        });
    } else {
      setRelStories([]);
    }
    setMetypeTarget(story.id);
    setMetypeBar(true);
  }, [story]);
  const children =
    imageElements && imageElements.length > 0
      ? imageElements.map((item, index) => <LightBox element={item} isCarousel={true} key={index} />)
      : null;

  const getCarouselIndex = (element) => {
    return imageElements.findIndex((item) => item.id === element.id);
  };

  const closeEvent = (e) => {
    setShowCarousel(!showCarousel);

    exitFullscreenWindow();
  };

  const carouselEvent = (e, element) => {
    setShowCarousel(!showCarousel);
    setCarouselIndex(getCarouselIndex(element));
  };

  const adTitle = staticTexts(publisherAttributes.lang).advertising;

  const renderingMeTypeBar = () =>
    !!(isMetypeBar && metypeTarget === get(metypeRef, ["current", "classList", "value"], ""));

  if (typeof document !== "undefined") {
    renderingMeTypeBar();
  }

  const toggleShare = () => setSocialShare(!isSocialShare);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setSocialShare(false);
    }
  };

  useEffect(() => {
    if (global.deviceWidth > 876) {
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }
  });

  const exitFullscreenWindow = () => {
    if (document.fullscreenElement) {
      document
        .exitFullscreen()
        .then(() => console.log("exited form Full Screen mode"))
        .catch((err) => console.error(err));
    }
  };

  const makeFullScreen = () =>
    document.fullscreenElement ? exitFullscreenWindow() : document.documentElement.requestFullscreen();

  const printStory = (storyUrl) => {
    window.onafterprint = function (event) {
      window.location.href = storyUrl;
    };
    window.print();
  };

  return (
    <React.Fragment>
      <div styleName="story-content-wrapper">
        <div className={`story-content ${!checkKeyElements ? "no-key-elements" : ""}`}>
          {showCarousel && (
            <div styleName="scroll-snap">
              <ScrollSnap
                leftArrow={
                  <LeftArrowButton color={isMobile ? "#fff0" : "#ffffff66"} color2={isMobile ? "#ffffff" : "#000000"} />
                }
                rightArrow={
                  <RightArrowButton
                    color={isMobile ? "#fff0" : "#ffffff66"}
                    color2={isMobile ? "#ffffff" : "#000000"}
                  />
                }
                isIndicator={!isMobile}
                defaultSelection={carouselIndex}
                selectionChange={selectionChange}
              >
                {children}
              </ScrollSnap>
              <div styleName="icons">
                <span styleName="image-index">{`${
                  publisherAttributes.lang === "en" ? selectedIndex + 1 : toBanglaNum(selectedIndex + 1)
                } / ${
                  publisherAttributes.lang === "en" ? imageElements.length : toBanglaNum(imageElements.length)
                }`}</span>
                <img src={`${assetify(FullScreenIcon)}`} styleName="full-screen-icon" onClick={makeFullScreen}></img>
                <span onClick={() => closeEvent()} className="close">
                  <CloseIcon color="#e2e2e2" />
                </span>
              </div>
            </div>
          )}
          <div>
            {!isMobile && sponsorId === null && (
              <div styleName={`adslot adslot-300x250`} className="print-adslot">
                <div styleName="advertising">{staticTexts(publisherAttributes.lang).advertising}</div>
                <DfpAd
                  adtype={publisherAttributes.lang === "en" ? "EnPalo_InArticle_300x250" : "News_InArticle_300x250"}
                  targetStory={story}
                  slotId={`story_${scrollIndex}-inArticle`}
                />
              </div>
            )}
            {slicedStoryCards.length > 0 &&
              slicedStoryCards.map((card, index) => {
                return (
                  <div key={card.id} id={card.id}>
                    {carouselIndex}
                    <StoryCard
                      card={card}
                      story={story}
                      onCarouselEvent={carouselEvent}
                      publisherAttributes={publisherAttributes}
                      domainSlug={domainSlug}
                      imageElements={imageElements}
                    />

                    {sponsorId === null && (
                      <StoryAds
                        slicedStoryCards={slicedStoryCards}
                        index={index}
                        adTitle={adTitle}
                        story={story}
                        scrollIndex={scrollIndex}
                        isMobile={isMobile}
                      />
                    )}
                  </div>
                );
              })}
          </div>
          {story.tags && story.tags.length > 0 && (
            <div styleName="tags wrapper" className="print-tags">
              {sectionName && (
                <Link
                  href={sectionName["section-url"]}
                  styleName="sub-section-name"
                  data-tracking-category={datatrackingcategory}
                  data-tracking-action={datatrackingaction}
                  data-tracking-label={sectionName["display-name"]}
                >
                  {publisherAttributes.lang === "en"
                    ? story["story-template"] === "photo"
                      ? "Watch more from "
                      : "Read more from "
                    : ""}
                  <span styleName="section-name">{sectionName["display-name"]}</span>
                  {publisherAttributes.lang === "bn"
                    ? story["story-template"] === "photo"
                      ? " থেকে আরও দেখুন"
                      : " থেকে আরও পড়ুন"
                    : ""}
                </Link>
              )}
              <StoryTag tags={story.tags} />
            </div>
          )}
        </div>
        <div>
          {!isMobile && relStories.length > 0 && (
            <div styleName="related-stories-wrapper" className="print-related-stories-wrapper">
              <RelatedStories stories={relStories.slice(0, 4)} story={story} />
            </div>
          )}
        </div>
      </div>
      <div styleName="comments-b1-ads-wrapper">
        <div>
          <div styleName="metype-reactions-with-comments" className="print-metype-reactions-with-comments">
            {publisherAttributes.showMetypeReactions && (
              <MetypeReactionsWidget
                host={metypeConfig.metypeHost}
                accountId={metypeConfig.metypeAccountId}
                storyUrl={story.url}
                storyId={story.id}
              />
            )}
            <div styleName={`metype-wrapper wrapper ${publisherAttributes.showMetype ? "" : "no-metype"}`}>
              {publisherAttributes.showMetype && (
                <div styleName="commment-text">{staticTexts(publisherAttributes.lang).doComment}</div>
              )}

              <div styleName="bottom-icons">
                <SocialShare template={SocialShareTemplate} title={story.headline} fullUrl={encodeURI(story.url)} />
                <span styleName="share-button" ref={ref}>
                  <span onClick={toggleShare}>
                    <Share color1="#eee" color2="#222" />
                  </span>
                  {isSocialShare && (
                    <SocialShare
                      template={ShareAllTemplate}
                      title={story.headline}
                      fullUrl={encodeURI(story.url)}
                      toggleShare={toggleShare}
                    />
                  )}
                </span>
                {publisherAttributes.showBookmark && (
                  <span styleName="bookmark">
                    <BookmarkViewIcon story={story} />
                  </span>
                )}
                <span onClick={() => printStory(encodeURI(story.url))}>
                  <Print bgcolor="#eee" color="#222" />
                </span>
              </div>
            </div>
          </div>
          <div ref={metypeRef} className={storyFromReducer.id}>
            {publisherAttributes.showMetype && renderingMeTypeBar() ? (
              <MetypeCommentWrapper
                metypeConfig={metypeConfig}
                storyUrl={storyFromReducer.url}
                metype={isMetypeBar}
                jwtToken={jwtToken}
                authHost={authHost}
                lang={publisherAttributes.lang}
                member={member}
              />
            ) : publisherAttributes.showMetype ? (
              <Loadericon color="#ed1c24" width="44" height="44" />
            ) : null}
          </div>
        </div>
        {lang !== "en" && (
          <div styleName={`adslot adslot-r2`} className="print-adslot">
            <div styleName="advertising">{adTitle}</div>
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2"}
              targetStory={story}
              slotId={`story_${scrollIndex}-R2`}
            />
          </div>
        )}
      </div>
      <div
        styleName={`adslot ${publisherAttributes.lang === "en" ? "en-adslot-728x90" : "adslot-728x90"}`}
        className="print-adslot"
      >
        <div styleName="advertising">{adTitle}</div>
        <DfpAd
          adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_728x90_B2" : "News_728x90_B2"}
          targetStory={story}
          slotId={`story_${scrollIndex}-B2`}
        />
      </div>
      {!isMobile && relStories.length > 4 && (
        <div className="print-latest-stories-wrapper">
          <LatestStories stories={relStories.slice(4, 8)} story={story} />
        </div>
      )}
      {isMobile && relStories.length > 0 && (
        <div styleName="related-stories-wrapper" className="print-related-stories-wrapper">
          <RelatedStories stories={relStories.slice(0, 4)} isMobile={isMobile} story={story} />
        </div>
      )}
    </React.Fragment>
  );
};

StoryContent.propTypes = {
  story: object.isRequired,
  metypeConfig: object,
  slicedStoryCards: array,
  checkKeyElements: bool,
  imageElements: array,
  domainSlug: string,
  isMetypeBar: bool,
  setMetypeBar: func,
  publisherAttributes: object,
  isMobile: bool,
  jwtToken: string,
  authHost: string,
  bottomAd: bool,
  bottomAdPresence: bool,
  member: object,
  storyFromReducer: object,
  customAds: object,
  scrollIndex: number,
  datatrackingcategory: string,
  datatrackingaction: string,
  sponsorId: number,
  lang: string,
};

const mapStateToProps = (state) => ({
  member: state.member,
  domainSlug: get(state, ["qt", "domainSlug"]),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
  isMetypeBar: get(state, ["metypeReducer", "isMetypeBar"], true),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  bottomAdPresence: get(state, ["breakingNewsAdReducer", "adPresence"], false),
  bottomAd: get(state, ["TopAndBottomAdReducer", "showAd"], false),
  storyFromReducer: get(state, ["headerReducer", "showStoryHeader"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  setMetypeBar: (flag) => dispatch(setMetypeBar(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryContent);
